if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

if (!customElements.get('custom-buy-now')) {
  customElements.define(
    'custom-buy-now',
    class CustomBuyNow extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.button = this.querySelector('button');
        this.buttonText = this.querySelector('.custom-buy-now-text');
        this.defaultText = this.buttonText ? this.buttonText.textContent.trim() : 'Buy it now';
        this.sectionId = this.dataset.sectionId;
        this.productFormId = this.dataset.productFormId;

        this.button?.addEventListener('click', this.onClick.bind(this));

        // Reset loading state when navigating back from checkout (bfcache)
        this.resetLoadingHandler = this.resetLoadingState.bind(this);
        window.addEventListener('pageshow', this.resetLoadingHandler);
        window.addEventListener('pagehide', this.resetLoadingHandler);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data && event.data.sectionId === this.sectionId) {
              this.onVariantChange(event.data.variant);
            }
          });
        }

        this.initObserver();
      }

      disconnectedCallback() {
        if (this.resetLoadingHandler) {
          window.removeEventListener('pageshow', this.resetLoadingHandler);
          window.removeEventListener('pagehide', this.resetLoadingHandler);
        }
        if (this.unsubscribe) this.unsubscribe();
        if (this.observer) this.observer.disconnect();
      }

      resetLoadingState() {
        if (this.button) {
          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
        }
        const spinner = this.querySelector('.loading-overlay__spinner');
        if (spinner) {
          spinner.classList.add('hidden');
        }
      }

      initObserver() {
        const submitBtn = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (!submitBtn) return;

        this.observer = new MutationObserver(() => {
          const isDisabled = submitBtn.hasAttribute('disabled') || submitBtn.getAttribute('aria-disabled') === 'true';
          if (isDisabled) {
            this.button.setAttribute('disabled', 'disabled');
            const submitText = submitBtn.querySelector('span')?.textContent?.trim();
            if (submitText && this.buttonText) {
              this.buttonText.textContent = submitText;
            }
          } else {
            this.button.removeAttribute('disabled');
            if (this.buttonText) {
              this.buttonText.textContent = this.defaultText;
            }
          }
        });

        this.observer.observe(submitBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      }

      onVariantChange(variant) {
        if (!this.button) return;
        if (!variant) {
          this.button.setAttribute('disabled', 'disabled');
          if (this.buttonText) this.buttonText.textContent = window.variantStrings?.unavailable || 'Unavailable';
          return;
        }

        if (!variant.available) {
          this.button.setAttribute('disabled', 'disabled');
          if (this.buttonText) this.buttonText.textContent = window.variantStrings?.soldOut || 'Sold out';
        } else {
          this.button.removeAttribute('disabled');
          if (this.buttonText) this.buttonText.textContent = this.defaultText;
        }
      }

      onClick(e) {
        e.preventDefault();
        e.stopPropagation();

        if (this.button.hasAttribute('disabled') || this.button.getAttribute('aria-disabled') === 'true') {
          return;
        }

        const form = this.closest('form') || document.getElementById(this.productFormId);
        const variantInput = form ? form.querySelector('input[name="id"]') : null;
        const variantId = variantInput ? variantInput.value : '';

        if (!variantId) return;

        const qtyInput =
          form?.querySelector('input[name="quantity"]') ||
          document.querySelector(`[form="${this.productFormId}"][name="quantity"]`) ||
          document.getElementById(`Quantity-${this.sectionId}`);

        let qty = 1;
        if (qtyInput && qtyInput.value) {
          const parsed = parseInt(qtyInput.value, 10);
          if (!isNaN(parsed) && parsed > 0) {
            qty = parsed;
          }
        }

        this.button.classList.add('loading');
        const spinner = this.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const baseUrl = (window.routes?.cart_url || '/cart').replace(/\/$/, '');
        let checkoutUrl = `${baseUrl}/${variantId}:${qty}`;

        const sellingPlanInput = form ? form.querySelector('input[name="selling_plan"]') : null;
        if (sellingPlanInput && sellingPlanInput.value) {
          checkoutUrl += `?selling_plan=${encodeURIComponent(sellingPlanInput.value)}`;
        }

        const propertyInputs = form ? form.querySelectorAll('[name^="properties["]') : [];
        if (propertyInputs && propertyInputs.length > 0) {
          const params = new URLSearchParams();
          propertyInputs.forEach((input) => {
            if (input.value && !input.disabled) {
              params.append(input.name, input.value);
            }
          });
          const paramStr = params.toString();
          if (paramStr) {
            checkoutUrl += (checkoutUrl.includes('?') ? '&' : '?') + paramStr;
          }
        }

        const currentUrlParams = new URLSearchParams(window.location.search);
        const discount = currentUrlParams.get('discount');
        if (discount) {
          checkoutUrl += (checkoutUrl.includes('?') ? '&' : '?') + `discount=${encodeURIComponent(discount)}`;
        }

        window.location.href = checkoutUrl;
      }
    }
  );
}

